import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SurveyNdgDataFisRequest, SurveyNdgDataGiuRequest, SurveyNewNeedsRequest, SurveyNewPrevidenceRequest, SurveyNewProtectionFisRequest, SurveyNewProtectionGiuRequest, SurveyNewSavingsRequest, SurveyNewSavingsShortListRequest } from 'src/app/model/survey-request';
import { SurveyNewIdResponse, SurveyForList, SurveyNewShortListResponse, SurveyResponse } from 'src/app/model/survey-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  public $newSurvey: Subject<SurveyForList> = new Subject<SurveyForList>();

  constructor(
    private http: HttpClient
  ) {}

  getSurveyInfo(surveyId: string): Observable<SurveyResponse> {
    return this.http.get<SurveyResponse>(environment.api.survey + '/' + surveyId);
  }

  insertNdgDataFis(payload: SurveyNdgDataFisRequest): Observable<SurveyNewIdResponse> {
    return this.http.post<SurveyNewIdResponse>(environment.api.survey + '/new/ndg-data-fis', payload);
  }

  insertNdgDataGiu(payload: SurveyNdgDataGiuRequest): Observable<SurveyNewIdResponse> {
    return this.http.post<SurveyNewIdResponse>(environment.api.survey + '/new/ndg-data-giu', payload);
  }

  insertNeedsFis(surveyId: string, payload: SurveyNewNeedsRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/needs-fis', payload);
  }

  insertNeedsGiu(surveyId: string, payload: SurveyNewProtectionGiuRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/needs-giu', payload);
  }

  insertProtection(surveyId: string, payload: SurveyNewProtectionFisRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/protection', payload);
  }

  insertSavingsData(surveyId: string, payload: SurveyNewSavingsRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/savings', payload);
  }

  getShortList(surveyId: string): Observable<SurveyNewShortListResponse[]> {
    return this.http.get<SurveyNewShortListResponse[]>(environment.api.survey + '/new/' + surveyId + '/short-list');
  }

  insertSavingsShortListData(surveyId: string, payload: SurveyNewSavingsShortListRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/savings-short-list', payload);
  }

  insertPrevidenceData(surveyId: string, payload: SurveyNewPrevidenceRequest): Observable<void> {
    return this.http.post<void>(environment.api.survey + '/new/' + surveyId + '/previdence', payload);
  }

  completeSurvey(surveyId: string): Observable<SurveyForList> {
    return this.http.post<SurveyForList>(environment.api.survey + '/new/' + surveyId + '/complete', null);
  }
}
